import { z } from "zod"
import { useSafeLocalStorage } from "~/hooks/useSafeLocalStorage"
import { api } from "~/utils/api"
import Select from "~/components/reusable/Select"

export const LifecycleStageOptions = [
  {
    label: "Live",
    value: "live",
  },
  {
    label: "Training",
    value: "training",
  },
  {
    label: "POC",
    value: "poc",
  },
  {
    label: "Data Setup",
    value: "data_setup",
  },
  {
    label: "Unset",
    value: null,
  },
  {
    label: "Paused",
    value: "paused",
  },
  {
    label: "Not Customer",
    value: "not_customer",
  },
]
function useDisplayLifecycleStages() {
  return useSafeLocalStorage("displayLifecycleStages", [], z.array(z.string().nullable()), true)
}

export function useDisplayCompanies(refetchInterval?: number) {
  const { data: companies } = api.company.getAll.useQuery(undefined, {
    refetchInterval,
  })
  const [lifecycleStagesToDisplay] = useDisplayLifecycleStages()

  return lifecycleStagesToDisplay.length > 0
    ? companies?.filter((company) => lifecycleStagesToDisplay.includes(company.lifecycleStage))
    : companies
}

export function DisplayLifecycleStagesSelector() {
  const [displayLifecycleStages, setDisplayLifecycleStages] = useDisplayLifecycleStages()
  return (
    <Select
      isMulti
      placeholder="Lifecycle stage"
      size="sm"
      options={LifecycleStageOptions}
      value={LifecycleStageOptions.filter((o) => displayLifecycleStages.some((s) => s === o.value))}
      onChange={(operator) => setDisplayLifecycleStages(operator.map((o) => o.value))}
    />
  )
}
